/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Badoo - לפגוש אנשים חדשים, לשוחח ולהכיר",
      "מספר טלפון שגוי",
      "Get the app",
      "להמשיך עם Apple",
      "להמשיך עם פייסבוק",
      "להמשיך עם גוגל",
      "התחברות",
      "הצטרפות",
      "כדי להמשיך, נא להקליד את האותיות הבאות בשורה למטה.",
      "המשך",
      "הקלידו את האותיות",
      "בדיקת אבטחה",
      "ריענון",
      "צרו סיסמה חדשה, כדאי כזו שקל לזכור:",
      "עדכון",
      "אימות סיסמה",
      "הסיסמה חייבת להכיל לפחות {{num}} [[characters:num]]",
      "סיסמה",
      "יצירת סיסמה חדשה",
      "Badoo - הבלוג",
      "קריירות",
      "צ'אט",
      "ערים",
      "מדיניות ה-Cookies",
      "זכויות יוצרים © 2006 – עד להווה. Bumble. כל הזכויות שמורות.",
      "Apple והלוגו של Apple הם סימנים מסחריים רשומים של Apple Inc.{{__EOL__}}Google Play הוא סימן מסחרי רשום של Google LLC.",
      "הורדה",
      "פייסבוק",
      "עקבו אחרינו",
      "מרכז העזרה",
      "אינסטגרם",
      "שפה",
      "לינקדאין",
      "סקירה כללית",
      "Badoo הוא חלק מ-Bumble Inc.",
      "מדיניות פרטיות",
      "מרכז הבטיחות",
      "מפת האתר",
      "הכרזה בנוגע לחוק העבדות המודרנית",
      "תנאי שימוש",
      "טוויטר",
      "נא להקליד את האימייל או מספר הטלפון שלך, ונשלח לך הנחיות ליצירת סיסמה חדשה.",
      "יצירת סיסמה חדשה",
      "אימייל או מספר טלפון",
      "שחזור סיסמה",
      "הדוגמנים והדוגמניות לצרכי המחשה בלבד",
      "Get the app",
      "We’re excited to bring renewed support, helpful technology, and safer experiences to help foster relationships formed with greater confidence. This is all part of Badoo’s commitment to being the app that builds dating confidence.",
      "We’ll continue to pioneer dating technology to meet the needs of daters as identified in this report, starting with the release of ‘<b><a href=\"{{url}}\">Deception Detector™</a></b>’, a machine learning model that has demonstrated <b>99.5% precision</b> in combating spam, scam and fake accounts.",
      "We remain <b>committed</b> to the responsible use of Artificial Intelligence (A.I.), ensuring human intelligence comes first and A.I. capabilities don’t damage the <b>authenticity</b> of our community;",
      "We’ll no longer contribute to the creation of dating trends that fuel <b>negative perceptions</b> and <b>behaviours</b>;",
      "We’ll work to identify <b>bad behaviour</b> in dating so we can minimise its impact on our community’s well-being;",
      "We’ll only work with influencer talent who we think are <b>authentic</b> and <b>realistic</b> in how they present themselves online;",
      "Take me to Badoo",
      "Our Confidence Commitments:",
      "We’ve published this report for daters, dating communities, and online platforms—anyone—to be able to use the findings to help people have a kinder, more enjoyable experience with greater possibilities than ever before.",
      "At Badoo, we know there’s work to be done. Our teams have studied findings and are making changes so we can play our part. But there are also immediate commitments we’ve decided to make.",
      "At a pivotal moment when we believe human connection has never been more valuable, and people having confidence in how they can form connections has never been more important, we have created an <b>industry first Dating Confidence Report.</b>",
      "Download the report",
      "Badoo has always been a pioneer in dating, creating one of the first online dating platforms in the world and being the first to reach 100 million downloads.",
      "The report details behaviours, attitudes and influences that have negatively influenced dating, supported by expert guidance on how we can enjoy more of the best parts—and be better equipped to manage (or change) the parts we’d all rather avoid.",
      "Being intentional: relaxing, being present, and being themselves in their dating experiences—on and offline",
      "Being able to ignore what they see on social media, and focus on what works for them;",
      "Feeling they can trust that who they’re seeing or speaking to is for real;",
      "Feeling clear in their own intentions and trusting that their matches are being genuine, too;",
      "Reducing paranoia and hypervigilance about negative dating behaviour;",
      "The key ingredients for greater dating confidence are:",
      "We believe this is the dating world’s biggest barrier to its potential—and our commitment to breaking this barrier has begun. Every year, instead of focusing on dating trends, we’ll track our own progress in building dating confidence and continue to assess the challenges daters face across the industry.",
      "The findings will lead to annual Confidence Commitments and innovations in our product to help minimise dating experiences that damage people’s confidence. Ultimately this’ll help make online dating a kinder, <b><u><a href=\"{{url}}\">safer</a></u></b> and more valuable experience for those who want meaningful connections. Our commitments for 2024 are below.",
      "Read Confidence Commitments",
      "The report shows us in no uncertain terms that dating confidence is at an all-time low for many singles.",
      "לא צריך לחכות להתאמה.{{__EOL__}}{{__EOL__}}אפשר לקפוץ ישר לתוך הצ'אטים העמוקים, ישר למה שמעניין. כשבאמת לומדים להכיר זה את זו.",
      "רוצה להתחיל לשוחח?",
      "עם ההירשמות הינך מסכים <a class=\"link\" href=\"{{terms_url}}\">לתנאי השירות</a> שלנו. <a class=\"link\" href=\"{{privacy_url}}\">במדיניות הפרטיות</a> מוסבר כיצד אנחנו משתמשים במידע שלך.",
      "עוזרים לך להראות יותר מעצמך, <br />כי כולם רוצים להרגיש בנוח בדייטינג.",
      "שיהיה לכולנו דייטינג נעים ובטוח.",
      "או",
      "כבר יש לך משתמש?",
      "הרשמו עם האימייל או מספר הטלפון",
      "דייטינג בשביל מה שבאמת רוצים.{{__EOL__}}בלי התנצלויות.",
      "בעניין של צ'אט? בכיף.{{__EOL__}}רוצה כבר בית וילדים? מצוין.{{__EOL__}}{{__EOL__}}ואם פתאום בא לך אחרת, תמיד אפשר לשנות.",
      "אני כאן לדייטים",
      "רוצה מערכת יחסים",
      "פתוח לשיחה",
      "רוב האנשים רוצים את אותו דבר.",
      "{{name}}, {{age}}",
      "הבטיחות שלכם היא העדיפות הגבוהה ביותר שלנו.",
      "\"מרכז הבטיחות\" שלנו מרכז תמיכה מכל הסוגים, כדי לעזור לכם לצאת לדייטים בתחושת ביטחון.",
      "בקרו במכרז הבטיחות שלנו",
      "דבר ראשון:<br/>בטיחות.",
      "מהרגע הראשון, אמרתי לעצמי שזה זה...",
      "בהתחלה, לא חיפשתי משהו רציני מדי...",
      "עצה לכל מי שבאפליקציה של Badoo, תהיו עצמכם...",
      "סיפורי הצלחה של Badoo",
      "גלו סיפורי הצלחה נוספים",
      "{{num}}__CUT__דירוג",
      "Apple App Store",
      "אפשר לסמוך עלינו. מאז 2006, הפגשנו כבר מיליוני (על מיליוני, על מיליוני) אנשים.",
      "{{num}} מיליון+__CUT__הורדות",
      "{{num}} מיליון+",
      "Google Play Store",
      "אנחנו יודעים מה אנחנו עושים.",
      "התחברו עם האימייל או מספר הטלפון",
      "הקלידו את הסיסמה",
      "שכחתם את הסיסמה?",
      "הרשמה",
      "אין לך חשבון משתמש?",
      "התחברות",
      "הרשמה"
],

    // These are the common words found in the lexemes of the app
    common: {
      "characters": {
            "many": [
                  "אותיות"
            ],
            "plural": [
                  "אותיות"
            ],
            "singular": [
                  "אות"
            ],
            "two": [
                  "אותיות"
            ]
      },
      "day": {
            "many": [
                  "ימים"
            ],
            "plural": [
                  "ימים"
            ],
            "singular": [
                  "יום"
            ],
            "two": [
                  "יומיים"
            ]
      },
      "hour": {
            "many": [
                  "שעות"
            ],
            "plural": [
                  "שעות"
            ],
            "singular": [
                  "שעה"
            ],
            "two": [
                  "שעתיים"
            ]
      },
      "minute": {
            "many": [
                  "דקות"
            ],
            "plural": [
                  "דקות"
            ],
            "singular": [
                  "דקה"
            ],
            "two": [
                  "דקות"
            ]
      },
      "month": {
            "many": [
                  "חודשים"
            ],
            "plural": [
                  "חודשים"
            ],
            "singular": [
                  "חודש"
            ],
            "two": [
                  "חודשיים"
            ]
      },
      "second": {
            "many": [
                  "שניות"
            ],
            "plural": [
                  "שניות"
            ],
            "singular": [
                  "שניה"
            ],
            "two": [
                  "שניות"
            ]
      },
      "year": {
            "many": [
                  "שנים"
            ],
            "plural": [
                  "שנים"
            ],
            "singular": [
                  "שנה"
            ],
            "two": [
                  "שנתיים"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
